const isFilled = (value: unknown): boolean => (
  Array.isArray(value) ? value.length > 0 : !!value
);

/**
 * Spocita, kolko filtracnych kriterii je zvolenych.
 *
 * Jedno kriterium = jedno filtracne pole tak, ako ho vidi pouzivatel: jeden panel
 * v bocnom filtri a jeden filter tag. Viac hodnot v jednom poli je preto stale
 * len jedno kriterium.
 *
 * groups je pre polia, ktore spolu tvoria jedno kriterium - typicky rozsah od/do,
 * ktory sa aj v tagoch zobrazuje ako jeden tag.
 */
export default <T extends object>(
  filter: T,
  groups: Array<Array<keyof T>> = [],
): number => {
  const groupedKeys = groups.reduce<Array<keyof T>>((acc, group) => acc.concat(group), []);

  const singleCount = (Object.keys(filter) as Array<keyof T>)
    .filter(key => !groupedKeys.includes(key))
    .filter(key => isFilled(filter[key]))
    .length;

  const groupCount = groups
    .filter(group => group.some(key => isFilled(filter[key])))
    .length;

  return singleCount + groupCount;
};
